//import { msalPluginInstance } from '../plugins/msal-plugin'
import oktaAuth from '@/plugins/oktaAuth'

const requestInterceptor = function (store) {
  return async req => {
    try {
      // Get token from local storage first
      let accessToken = await oktaAuth.tokenManager.get('accessToken')

      if (accessToken && !oktaAuth.tokenManager.hasExpired(accessToken)) {
        req.headers.Authorization = `Bearer ${accessToken.accessToken}`
      } else {
        const newToken = await oktaAuth.getAccessToken()
        if (newToken) {
          req.headers.Authorization = `Bearer ${newToken}`
        }
      }
      
      store.commit('updateApiCallStatus', {
        url: req.url,
        pageName: window.location.pathname,
        status: 'new',
      })
      // Important: request interceptors **must** return the request.
      return req
    } catch (error) {
      console.error('Token error: ', error)
      return req
    }
  }
}

const responseInterceptor = function (store) {
  return resp => {
    // each time you get a successful response, update api page failure
    store.commit('updateApiCallStatus', {
      url: resp.config.url,
      status: 'pass',
    })
    return resp
  }
}

const errorInterceptor = async function (store, router, axios) {
  return async error => {
    if (
      error?.response?.status === 403 &&
      error?.response?.data.indexOf('Error: User Not Active') > -1
    ) {
      await this.$auth.tokenManager.remove('accessToken')
      await this.$auth.signOut()
    }

    if (error?.response?.status === 500 && error?.message === 'Network Error') {
      store.commit('updateApiDown', true, {
        root: true,
      })
      console.log('main: axios response interceptor error - ' + error.message)
      // throw new Error(error)
      return Promise.reject(error)
    }

    if (
      error.response &&
      error.response.status === 401 &&
      !error.config._retry
    ) {
      const retRequest = error.config
      retRequest._retry = true
      console.log(
        'main: axios response interceptor - 401 detected, call auth/login',
      )
      try {
        // authorization denied, try refreshing tokens from auth provider
        // if login fails, user logged out, then redirected back to login per normal login UX
        await oktaAuth.signInWithRedirect()
        console.log('main: axios response interceptor - back from auth/login')
        // now retry the original request with updated headers
        let newToken = await oktaAuth.tokenManager.get('accessToken')
        retRequest.headers.Authorization = `Bearer ${newToken.accessToken}`
        console.log(
          'main: axios response interceptor - resubmit original request',
        )
        return await axios(retRequest)
      } catch (err) {
        console.log('main: axios response interceptor error - ' + err)
      }
    }

    // if the auth passes and there's no network error but
    // the /api/user/profile call fails,
    // show the 500 screen (since they can't do anything else).
    // Otherwise, show a page alert.
    if (error?.config?.url === '/user/profile') {
      store.commit('updateApiDown', true, {
        root: true,
      })
    } else {
      if (error?.config?.url) {
        store.commit('updateApiCallStatus', {
          url: error.config.url,
          pageName: window.location.pathname,
          status: 'fail',
        })
      }
      // No 401, 403 or 500 Network Error? Just log the message.
      console.log('main: axios response interceptor error - ' + error.message)
      return Promise.reject(error)
    }
  }
}

export { errorInterceptor, requestInterceptor, responseInterceptor }
